import React from "react";
import {
  View,
  Pressable,
  Text,
  Image,
  StyleProp,
  ImageStyle,
  ViewStyle,
  TextStyle,
  Platform,
} from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

interface ActionTabsProps {
  onPress: () => void;
  title: string;
  icon: any;
  tileColor: string;
  iconStyle?: StyleProp<ImageStyle>;
  tileIcon?: any;
  tileContainerStyle: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  textStyleContainer?: StyleProp<TextStyle>;
  tileContainerStyleIds?: any;
}

const ActionTabs = ({
  onPress,
  title,
  icon,
  tileColor,
  iconStyle,
  tileIcon,
  tileContainerStyle,
  tileContainerStyleIds,
  containerStyle: propContainerStyle,
  textStyleContainer,
}: ActionTabsProps) => {
  return (
    <View
      style={[
        styles.containerStyle,
        { backgroundColor: tileColor },
        propContainerStyle,
      ]}
      dataSet={{ media: ids.containerStyle }}
    >
      <Pressable
        onPress={onPress}
        style={[tileContainerStyle, { backgroundColor: tileColor }]}
        dataSet={{ media: tileContainerStyleIds }}
        testID={`action-page-tile-${title
          ?.toLowerCase()
          ?.replaceAll(" ", "-")}`}
      >
        <View
          style={styles.imageContainer}
          dataSet={{ media: ids.imageContainer }}
        >
          <Image
            source={tileIcon}
            style={iconStyle}
            resizeMode="contain"
            testID={`action-page-tile-${title
              ?.toLowerCase()
              ?.replaceAll(" ", "-")}-icon`}
          />
        </View>
        <Text
          style={[styles.textStyle, textStyleContainer]}
          dataSet={{ media: ids.textStyle }}
          testID={`action-page-tile-${title
            ?.toLowerCase()
            ?.replaceAll(" ", "-")}-label`}
        >
          {title}
        </Text>
        <Image
          source={icon}
          style={styles.iconStyleOpaque}
          resizeMode="contain"
          testID={`action-page-tile-${title
            ?.toLowerCase()
            ?.replaceAll(" ", "-")}-icon`}
        />
      </Pressable>
    </View>
  );
};

export default ActionTabs;

export const { ids, styles } = createPlatformStyles({
  mobile: {
    containerStyle: {
      flex: 1,
      height: 120,
      minHeight: 120,
      borderRadius: theme.radius.xxss,
      overflow: "hidden",
      "@media (min-width: 600px)": {
        width: "100%",
        height: 160,
        minHeight: 160,
      },
    },
    textStyle: {
      width: "100%",
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.white,
      fontSize: theme.fontsize.lg,
      textAlign: "center",
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.mmd,
        marginLeft: theme.margin.xlg,
        width: "80%",
        textAlign: "left",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.lg,
        marginLeft: theme.margin.xl,
        width: "80%",
      },
    },
    iconStyleOpaque: {
      width: 90,
      height: 90,
      position: "absolute",
      right: -20,
      bottom: -20,
    },
    imageContainer: {
      flex: 1,

      alignItems: "center",
      justifyContent: "center",
      "@media (max-width: 485px)": {
        transform: [{ scale: 0.5 }],
        flex: 0.7,
        marginLeft: theme.margin.ssm,
      },
    },
  },
  web: {
    containerStyle: {
      flex: 1,
      height: 190,
      minHeight: 140,
      borderRadius: theme.radius.xxss,
      overflow: "hidden",
    },
    textStyle: {
      width: "100%",
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.white,
      fontSize: theme.fontsize.md,
      fontWeight: theme.fontweight.bold,
      textAlign: "center",
      "@media (min-width: 485px)": {
        fontSize: theme.fontsize.mmd,
        marginLeft: theme.margin.lg,
        width: "80%",
        textAlign: "left",
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.lg,
        marginLeft: theme.margin.lg,
        width: "80%",
      },
    },
    iconStyleOpaque: {
      width: 140,
      height: 140,
      position: "absolute",
      right: -50,
      bottom: -20,
    },
    imageContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      "@media (max-width: 485px)": {
        transform: [{ scale: 0.5 }],
        flex: 0.5,
        marginLeft: theme.margin.ssm,
      },
    },
  },
});
